import styled from 'styled-components';

import { media } from 'helpers/breakpoints';
import { InputWithIcon } from 'components/Toolkit/Inputs/InputWithIcon';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';

export interface LookupProps {
  title?: string;
  description?: string;
  inputIcon: string;
  inputIconColour: string;
  inputPlaceHolderText: string;
  ctaText: string;
  ctaLink: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme }) => theme.spacing.M16};
  max-width: 100%;
  gap: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
    flex-direction: row;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing.M24};
  }
`;

const SInfoTitle = styled(InfoTitle)`
  flex: 50%;
`;

const SInputWithIcon = styled(InputWithIcon)`
  display: flex;
  flex: 50%;
  align-items: center;
  width: 100%;
`;

function Lookup({
  title,
  description,
  inputIcon,
  inputIconColour,
  inputPlaceHolderText,
  ctaText,
  ctaLink,
}: LookupProps) {
  return (
    <Container>
      <SInfoTitle
        title={title && title}
        listItems={[`${description && description}`]}
      />
      <SInputWithIcon
        buttonText={ctaText}
        handleClick={() => {
          window.open(ctaLink, '_blank');
        }}
        id="test"
        name="test"
        icon={inputIcon}
        iconBackgroundColour={inputIconColour}
        placeholder={inputPlaceHolderText}
        willUseSubText={false}
      />
    </Container>
  );
}

export { Lookup };
